<div class="anc-search-bar-wrap">
    <div
        #searchBar
        class="anc-search-bar"
        [class.anc-search-bar--size-default]="size === 'default'"
        [class.anc-search-bar--size-compact]="size === 'compact'"
        [class.anc-search-bar--size-mini]="size === 'mini'"
        [class.anc-search-bar--type-default]="type === 'default'"
        [class.anc-search-bar--type-advance]="type === 'advance'"
        [class.anc-search-bar--disabled]="disabled"
        [class.anc-search-bar--focused]="focused"
        [class.anc-search-bar--searching]="isSearching"
        [ngbPopover]="termsPopoverTpl"
        [autoClose]="'outside'"
        triggers="manual"
        placement="bottom"
        container="body"
        popoverClass="anc-search-bar-terms-popover"
        #termsAnchor="ngbPopover"
    >
        <div
            *ngIf="type === 'advance'"
            class="anc-search-bar__category"
            [class.anc-search-bar__category--interactive]="categoryItems.length"
            [ngbPopover]="categoryItems.length ? categoryPopoverTpl : null"
            [autoClose]="'outside'"
            [disablePopover]="!categoryItems.length || disabled"
            placement="bottom-start"
            container="body"
            popoverClass="anc-search-bar-category-popover"
            #categoryAnchor="ngbPopover"
        >
            <span class="anc-search-bar__category-label">{{
                selectedCategoryLabel | translate
            }}</span>
            <span
                class="anc-search-bar__category-chevron icon icon-chevron-down"
                aria-hidden="true"
            ></span>
            <span class="anc-search-bar__divider" aria-hidden="true"></span>
        </div>

        <div class="anc-search-bar__field">
            <span
                class="anc-search-bar__search-icon icon icon-search"
                aria-hidden="true"
                (click)="onIconClick($event)"
            ></span>
            <div class="anc-search-bar__input-row">
                <div
                    *ngFor="let term of visibleTerms; trackBy: trackTerm"
                    class="anc-value-badge"
                    [class.anc-value-badge--mini]="size === 'mini'"
                >
                    <span class="anc-value-badge__label">{{ term }}</span>
                    <span
                        class="anc-value-badge__dismiss"
                        [class.anc-value-badge__dismiss--disabled]="disabled"
                        aria-hidden="true"
                        (click)="onRemoveTerm(term, $event)"
                    >
                        <span class="icon icon-close"></span>
                    </span>
                </div>
                <div
                    *ngIf="overflowTerms.length"
                    class="anc-value-badge anc-value-badge--overflow"
                    [class.anc-value-badge--mini]="size === 'mini'"
                    [class.anc-value-badge--disabled]="disabled"
                    (click)="onOverflowClick($event)"
                >
                    <span class="anc-value-badge__label">+{{ overflowTerms.length }}</span>
                </div>
                <input
                    #searchInput
                    type="search"
                    class="anc-search-bar__input"
                    [value]="value"
                    [placeholder]="terms.length ? '' : (placeholder | translate)"
                    [disabled]="disabled"
                    [attr.aria-label]="ariaLabel | translate"
                    (input)="onInput($event)"
                    (keydown.enter)="onEnter($event)"
                    (focus)="onFocus()"
                    (blur)="onBlur()"
                />
            </div>
        </div>

        <span
            *ngIf="showClearControl"
            class="anc-search-bar__clear icon icon-x"
            aria-hidden="true"
            (click)="onClearClick($event)"
        ></span>
    </div>
</div>

<ng-template #termsPopoverTpl>
    <div class="anc-search-bar__terms-pop" [style.width.px]="barWidth">
        <ul class="anc-search-bar__terms-list" role="listbox" aria-multiselectable="true">
            <li
                *ngFor="let term of terms; trackBy: trackTerm"
                class="anc-search-bar__terms-item"
                role="option"
                [attr.aria-selected]="true"
            >
                <input
                    type="checkbox"
                    [checked]="true"
                    [disabled]="disabled"
                    (click)="$event.stopPropagation()"
                    (change)="onRemoveTerm(term, $event)"
                />
                <span class="anc-search-bar__terms-item-label">{{ term }}</span>
            </li>
        </ul>
    </div>
</ng-template>

<ng-template #categoryPopoverTpl>
    <ul class="anc-search-bar__category-list" role="listbox">
        <li
            *ngFor="let item of categoryItems; trackBy: trackCategory"
            class="anc-search-bar__category-item"
            [class.anc-search-bar__category-item--selected]="
                item.value === categoryValue
            "
            role="option"
            [attr.aria-selected]="item.value === categoryValue"
            (click)="onCategorySelect(item)"
        >
            {{ item.label | translate }}
        </li>
    </ul>
</ng-template>
